import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WhatsAppWidget = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [messageCount, setMessageCount] = useState(0);

  useEffect(() => {
    // Show widget after 2 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    // Show tooltip periodically
    const tooltipTimer = setInterval(() => {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 3000);
    }, 15000);

    // Simulate new messages
    const messageTimer = setInterval(() => {
      setMessageCount(prev => prev + 1);
    }, 30000);

    return () => {
      clearTimeout(timer);
      clearInterval(tooltipTimer);
      clearInterval(messageTimer);
    };
  }, []);

  const handleWhatsAppClick = () => {
    const message = "Hello! I'm interested in Nitin Online Hub premium gaming services. Can you help me get started?";
    window.open(`https://wa.me/+917704070169?text=${encodeURIComponent(message)}`, '_blank');
    setMessageCount(0);
  };

  const handleTelegramClick = () => {
    window.open('https://t.me/+1iAesH3uLk83YTA1', '_blank');
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Desktop Widget */}
      <div className="hidden lg:block fixed bottom-6 right-6 z-50">
        <div className="relative">
          {/* Tooltip */}
          {showTooltip && (
            <div className="absolute bottom-full right-0 mb-4 bg-white rounded-lg shadow-royal p-4 w-64 animate-fade-in">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-gradient-royal rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="User" size={20} color="white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm">Gaming Expert</div>
                  <div className="text-gray-600 text-sm">
                    Hi! Need help with game strategies or have questions? I'm here to assist you 24/7!
                  </div>
                </div>
              </div>
              <div className="absolute bottom-0 right-4 transform translate-y-1/2 rotate-45 w-3 h-3 bg-white border-r border-b border-gray-200"></div>
            </div>
          )}

          {/* Main WhatsApp Button */}
          <button
            onClick={handleWhatsAppClick}
            className="relative w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full shadow-royal hover:shadow-glow transition-all duration-300 flex items-center justify-center animate-pulse-golden hover:animate-none group"
          >
            <Icon name="MessageCircle" size={28} color="white" />
            
            {/* Message Count Badge */}
            {messageCount > 0 && (
              <div className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
                <span className="text-white text-xs font-bold">
                  {messageCount > 9 ? '9+' : messageCount}
                </span>
              </div>
            )}

            {/* Pulse Ring */}
            <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20"></div>
          </button>

          {/* Secondary Actions */}
          <div className="mt-3 space-y-2">
            <button
              onClick={handleTelegramClick}
              className="w-12 h-12 bg-blue-500 hover:bg-blue-600 rounded-full shadow-subtle hover:shadow-royal transition-all duration-300 flex items-center justify-center group"
            >
              <Icon name="Send" size={20} color="white" />
            </button>
          </div>

          {/* Support Text */}
          <div className="mt-3 text-center">
            <div className="bg-white rounded-lg shadow-subtle p-2">
              <div className="text-xs font-medium text-gray-900">24/7 Support</div>
              <div className="text-xs text-gray-600">Gaming Expert</div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Sticky Bottom Bar */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-royal">
        <div className="px-4 py-3">
          <div className="flex items-center space-x-3">
            <div className="flex-1">
              <div className="text-sm font-semibold text-gray-900">Need Gaming Help?</div>
              <div className="text-xs text-gray-600">Speak to our expert now</div>
            </div>
            
            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="sm"
                onClick={handleTelegramClick}
                iconName="Send"
                iconPosition="left"
                className="border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white"
              >
                Telegram
              </Button>
              
              <Button
                variant="default"
                size="sm"
                onClick={handleWhatsAppClick}
                iconName="MessageCircle"
                iconPosition="left"
                className="bg-green-500 hover:bg-green-600 text-white animate-pulse-golden hover:animate-none relative"
              >
                WhatsApp
                {messageCount > 0 && (
                  <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xs font-bold">
                      {messageCount > 9 ? '9+' : messageCount}
                    </span>
                  </div>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Bottom Spacer */}
      <div className="lg:hidden h-20"></div>
    </>
  );
};

export default WhatsAppWidget;